import { v4 as uuidv4 } from 'uuid';

/**
 * Abstracts the uuidv4 module to make it easier to mock in unit tests
 * See HomeApiSagaTests.ts for example
 */
export const generateUuid = (): string => {
  return uuidv4();
};
